module.exports = __webpack_public_path__ + "static/img/code.bfbdd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code.png
// module id = 9OQK
// module chunks = 1